import {SmartComponent} from "smart-component-js";
import $ from "jquery";
import moment from "moment";
import Constants from "../business/Constants";
import PromoApi from "mbpromo/src/api/PromoApi";
import UrlHelper from "../helpers/url.helper";
class ThankYouCtrl extends SmartComponent {

	constructor(element, parentComponent, params) {
		super(element, parentComponent, params);
		this.promoApi = new PromoApi({promoCode: Constants.API_PROMOCODE});
		this.init();
	}

	init() {
		this.loadChildComponents(this);

		let istantWin = UrlHelper.getUrlParam('iw');
		if(istantWin === "1"){
			$('.iw-0').hide();
			$('.iw-1').show();
		}else{
			$('.iw-1').hide();
			$('.iw-0').show();
		}
	}
}

export default ThankYouCtrl;
